import { useAuthStore } from '~~/stores/auth'
import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

// Refresh the user once per app boot, even if a persisted copy exists
let userFetched = false

export default defineNuxtRouteMiddleware(async (to) => {
    const auth = useAuthStore()

    if (auth.authenticated && !userFetched) {
        if (auth.token) {
            auth.setToken(auth.token)
        }
        try {
            await auth.fetchUser()
            userFetched = true
        } catch (error) {
            // Offline (no response): keep going with the persisted user so the tablet stays usable (urgency list)
            if ((error as { response?: unknown })?.response || !auth.user) {
                throw error
            }
        }
    }

    if ((!auth.authenticated || !auth.user) && to.meta.layout !== 'auth') {
        return navigateTo('/auth/login')
    }
})
